import { t } from "@repo/translation";
import { DebouncedSearchField, SectionContainer } from "@repo/ui";
import { isDefined, searchWithNormalizedInclude } from "@repo/utils";
import isEmpty from "lodash/isEmpty";
import { useEffect, useState } from "react";

import { TagsListView } from "./TagsListView";
import { type GroupedTags, type Tags } from "./types";
import { groupObjectsByType } from "./utils";

interface TagsSearchSelectProps {
  onChange: (checked: boolean, item: Tags) => void;
  localState?: string[];
  tags: Tags[];
}

export const TagsGroup = ({
  onChange,
  localState,
  tags,
}: TagsSearchSelectProps) => {
  const [searchValue, setSearchValue] = useState<string>("");
  const [searchResult, setSearchResult] = useState<GroupedTags>({});

  const groups = groupObjectsByType(tags);

  const handleChange = (term: string) => {
    setSearchValue(term);
  };

  const handleSearch = () => {
    const tagsSearchResult: GroupedTags = {};
    Object.entries(groups).forEach(([groupName, groupItems]) => {
      const filteredItems = groupItems.filter((item: Tags) =>
        searchWithNormalizedInclude(
          searchValue,
          item.translationKey ? t(item.translationKey) : item.name
        )
      );

      if (filteredItems.length > 0) {
        tagsSearchResult[groupName] = filteredItems;
      }
    });
    setSearchResult(tagsSearchResult);
  };

  useEffect(() => {
    if (isEmpty(searchValue)) {
      setSearchResult(groups);
    } else {
      handleSearch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue]);

  return (
    <SectionContainer>
      <DebouncedSearchField
        id="seach-tag-input"
        data-testid="search-select-tag-modal"
        placeholder={t("action.placeholder_search")}
        value={searchValue}
        onChange={(term) => handleChange(term)}
      />

      {searchResult && (
        <TagsListView
          data-testid="tag-select-list"
          id="tag-select-list"
          selectedKeys={localState?.filter(isDefined) ?? []}
          onChange={onChange}
          searchResult={searchResult}
        />
      )}
    </SectionContainer>
  );
};
